import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { PortalButton } from "./PortalButton";
import logo from "../../assets/images/header-logo.png";

export default function PortalLoginCTA() {
  const { user } = useAuth();

  if (user) return null;

  return (
    <section style={sectionStyle}>
      <p style={eyebrowStyle}>40+ years of creator-owned comics. One platform.</p>

      <div style={cardStyle}>
        <div style={logoWrapStyle}>
          <img src={logo} alt="Antarctic Press" style={logoStyle} />
        </div>

        <h2 style={headlineStyle}>AP Portal</h2>

        <p style={subheadlineStyle}>Your personalized Antarctic Press experience.</p>

        <p style={bodyStyle}>
          Pick up reading where you left off. Track campaigns you&apos;ve backed.
          Discover comics, merch, collectibles, and auctions tailored to you.
        </p>

        <div style={buttonRowStyle}>
          <PortalButton
            variant="primary"
            onClick={() => window.location.assign("/portal/login")}
            style={buttonOverrideStyle}
          >
            Log In
          </PortalButton>

          <PortalButton
            variant="secondary"
            onClick={() => window.location.assign("/portal/signup")}
            style={buttonOverrideStyle}
          >
            Create Account
          </PortalButton>
        </div>
      </div>
    </section>
  );
}

const sectionStyle = {
  margin: "2rem 0 3rem 0",
};

const eyebrowStyle = {
  margin: "0 0 1.25rem 0",
  color: "rgba(255,255,255,0.45)",
  fontSize: "0.78rem",
  fontWeight: 700,
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  textAlign: "center",
};

const cardStyle = {
  background: "linear-gradient(160deg, #0d1520 0%, #111c2e 100%)",
  border: "1px solid #1e3050",
  borderRadius: "18px",
  padding: "4rem 2rem",
  textAlign: "center",
  boxShadow: "0 12px 36px rgba(0,0,0,0.28)",
};

const logoWrapStyle = {
  marginBottom: "1.75rem",
};

const logoStyle = {
  height: "80px",
  width: "auto",
  display: "inline-block",
  filter: "drop-shadow(0 4px 14px rgba(0,0,0,0.55))",
};

const headlineStyle = {
  margin: "0 0 0.6rem 0",
  color: "#ffffff",
  fontSize: "2.6rem",
  fontWeight: 800,
  lineHeight: 1.05,
  letterSpacing: "-0.01em",
};

const subheadlineStyle = {
  margin: "0 0 1.25rem 0",
  color: "#43c6f9",
  fontSize: "1.1rem",
  fontWeight: 400,
  lineHeight: 1.5,
};

const bodyStyle = {
  margin: "0 auto 2rem auto",
  color: "rgba(255,255,255,0.72)",
  fontSize: "1rem",
  lineHeight: 1.75,
  maxWidth: "560px",
};

const buttonRowStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "1rem",
  flexWrap: "wrap",
};

const buttonOverrideStyle = {
  padding: "0.85rem 2rem",
  fontSize: "1rem",
  fontWeight: 800,
  borderRadius: "10px",
};
